import React from 'react';
import './SubscriptionCard.scss';
import TickIcon from '../../../../../assets/TickIcon.png';
import UnderlineImage from '../../../../../assets/UnderlineImage.png';

export default function SubscriptionCard({
  planName,
  price,
  duration,
  savingsText,
  equivalentText,
  features,
  buttonLabel,
  isDefault
}) {
  const isYearly = duration.toLowerCase().includes('year');
  const ribbonColor = planName === 'Basic' ? '#6C4DAB' : '#B57F3D';

  return (
    <div
      className={`price-card-container new-style ${isYearly ? 'active' : ''}`}
      style={savingsText ? {border: `2px solid ${ribbonColor}`} : {}}
    >
      {savingsText && (
        <div className="ribbon" style={{ backgroundColor: ribbonColor }}>
          <span>{savingsText}</span>
        </div>
      )}

      <h2 className={`plan-name ${planName.toLowerCase()}`}>{planName}</h2>
      
      <div className="price-section">
        <h3>{price}$ <span className="duration">/ {duration}</span></h3>
        <div className='underline-image-container'>
          <img src={UnderlineImage} alt="Underline" />
        </div>
        {isYearly && <p className="equivalent">{equivalentText}</p>}
      </div>
      

      <ul className="features-list">
        {features.map(({ label }, index) => (
          <li key={index}>
            <img src={TickIcon} alt="tick" />
            {label}
          </li>
        ))}
      </ul>

      <button className={`avail-btn ${planName.toLowerCase()}`}>{buttonLabel}</button>
    </div>
  );
}
